export function toDolarCurrency(price) {
    price = parseFloat(price).toFixed(2);
    return `US$ ${price}`;
}